import { Header, HeaderLogo } from '.'
import { Back, Cart, NavMenu, OrderNow, ClaimRewardCodeButton } from './buttons'

const HeaderDefault = ({
  maxWidth = '100%',
  path,
  showOrderNow = true,
  showLogo = true,
  showClaimRewardCodeButton = false,
  hideLinks = false,
}: {
  maxWidth?: string
  path?: string
  showOrderNow?: boolean
  showLogo?: boolean
  showClaimRewardCodeButton?: boolean
  hideLinks?: boolean
}) => {
  return (
    <Header
      maxWidth={maxWidth}
      title={
        showLogo ? (
          <HeaderLogo />
        ) : (
          showClaimRewardCodeButton && <ClaimRewardCodeButton />
        )
      }
      left={hideLinks ? undefined : <Back path={path} />}
      right={
        hideLinks ? undefined : (
          <>
            {showLogo && showClaimRewardCodeButton && <ClaimRewardCodeButton />}
            <Cart />
            {showOrderNow && <OrderNow />}
            <NavMenu />
          </>
        )
      }
    />
  )
}

export default HeaderDefault
